<template>
  <div class="row">
    <div class="col-12">
      <div class="new-button-div">
        <n-button @click.native="openItemAdd()" type="primary" round>
          <i slot="label" class="now-ui-icons ui-1_simple-add"></i>
          {{ $t("app.modules.currencies.add.title") }}
        </n-button>
      </div>
      <card card-body-classes="table-full-width" no-footer-line>
        <div>
          <div
            class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
          >
            <h4 class="card-title text-purple">
              {{ this.$t("app.modules.currencies.title") }}
            </h4>
            <fg-input>
              <el-input
                type="search"
                class="mb-3"
                clearable
                prefix-icon="el-icon-search "
                style="width: 300px"
                :placeholder="$t('app.general.search')"
                v-model="searchQuery"
                aria-controls="datatables"
              >
              </el-input>
            </fg-input>
          </div>
          <el-table stripe style="width: 100%;" :data="queriedData">
            <el-table-column
              prop="idTipoMoneda"
              :label="this.$t('app.modules.currencies.headers.identifier')"
              sortable
              min-width="200"
            >
            </el-table-column>
            <el-table-column
              prop="nombre"
              :label="this.$t('app.modules.currencies.headers.name')"
              sortable
              min-width="200"
            >
            </el-table-column>
            <el-table-column
              prop="abreviatura"
              :label="this.$t('app.modules.currencies.headers.abbreviation')"
              sortable
              min-width="200"
            >
            </el-table-column>
            <el-table-column :label="$t('app.general.active')">
              <template slot-scope="props">
                <n-switch
                  v-model="props.row.activo"
                  @input="active(props.row)"
                  color="black"
                >
                  <i class="now-ui-icons ui-1_check" slot="on"></i>
                  <i class="now-ui-icons ui-1_simple-remove" slot="off"></i>
                </n-switch>
              </template>
            </el-table-column>
            <el-table-column
              :min-width="200"
              fixed="right"
              :label="$t('app.general.actions')"
            >
              <div slot-scope="props" class="table-actions dropdown">
                <el-popover
                  placement="bottom"
                  width="250"
                  trigger="click"
                  :ref="'refOption' + (props.$index + 1)"
                >
                  <div class="row">
                    <div class="col-12 options">
                      <n-button
                        @click.native="
                          EditItem(
                            props.$index,
                            props.row,
                            'refOption' + (props.$index + 1)
                          )
                        "
                        type="primary"
                        class="options-button"
                        size="sm"
                        round
                      >
                        {{ $t("app.modules.currencies.edit.title") }}
                      </n-button>
                    </div>
                  </div>
                  <n-button
                    slot="reference"
                    size="sm"
                    icon
                    class="button-options-table"
                  >
                    <i class="fa fa-ellipsis-v" style="color:black;"></i>
                  </n-button>
                </el-popover>
              </div>
            </el-table-column>
            <!-- <el-table-column :min-width="135" fixed="right" label="Acciones">
              <div slot-scope="props" class="table-actions dropdown">
                <n-button
                  @click.native="EditItem(props.$index, props.row)"
                  class="like"
                  type="info"
                  size="md"
                  round
                  icon
                >
                  <i class="fa fa-pencil"></i>
                </n-button>
              </div>
            </el-table-column>-->
          </el-table>
        </div>
        <div
          slot="footer"
          class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
        >
          <div class="">
            <p class="card-category">
              {{ $t("app.pagination.showing") }} {{ from + 1 }}
              {{ $t("app.pagination.of") }} {{ to }}
              {{ $t("app.pagination.of") }} {{ total }}
              {{ $t("app.pagination.records") }}
            </p>
          </div>
          <n-pagination
            class="pagination-no-border"
            v-model="pagination.currentPage"
            :per-page="pagination.perPage"
            :total="total"
          >
          </n-pagination>
        </div>
      </card>
      <monedas-add />
      <monedas-edit />
    </div>
  </div>
</template>
<script>
import { Pagination as NPagination } from "src/components";
import Fuse from "fuse.js";

export default {
  components: {
    NPagination,
    MonedasAdd: () => import("./monedasAdd"),
    MonedasEdit: () => import("./monedasEdit")
  },
  computed: {
    /***
     * Returns a page from the searched data or the whole data. Search is performed in the watch section below
     */
    queriedData() {
      let result = this.tableData;
      if (this.searchedData.length > 0) {
        result = this.searchedData;
      }
      // filter by search term
      result =
        this.searchQuery.length > 0
          ? result.filter(d => d.nombre.includes(this.searchQuery))
          : result;
      return result.slice(this.from, this.to);
    },
    to() {
      let highBound = this.from + this.pagination.perPage;
      if (this.total < highBound) {
        highBound = this.total;
      }
      return highBound;
    },
    from() {
      return this.pagination.perPage * (this.pagination.currentPage - 1);
    },
    total() {
      return this.searchedData.length > 0
        ? this.searchedData.length
        : this.tableData.length;
    }
  },
  data() {
    return {
      type: ["", "info", "success", "warning", "danger"],
      pagination: {
        perPage: 5,
        currentPage: 1,
        perPageOptions: [5, 10, 25, 50],
        total: 0
      },
      searchQuery: "",
      propsToSearch: ["name", "empresa"],
      tableColumns: [
        {
          prop: "idTipoMoneda",
          label: "Identificador",
          minWidth: 120
        },
        {
          prop: "nombre",
          label: "moneda",
          minWidth: 200
        },
        {
          prop: "abreviatura",
          label: "Abreviatura",
          minWidth: 150
        }
      ],
      tableData: [],
      searchedData: [],
      fuseSearch: null
    };
  },
  methods: {
    async init() {
      this.$swal.fire({
        title: this.$t("app.promps.wait"),
        html:
          '<div class="spinner-border text-primary" style="width: 3rem; height: 3rem;" role="status"><span class="sr-only">Loading...</span></div>',
        showConfirmButton: false
      });
      await this.$http
        .get(route("TipoMoneda/getTipoMoneda"))
        .then(
          async response => {
            console.log(response);
            if (response.body.code === 200) {
              this.tableData = response.body.tipoMoneda;
            } else {
              this.notifyMessage("danger", this.$t("app.promps.error"));
            }
          },
          error => {
            console.log(error);
            this.notifyMessage("danger", this.$t("app.promps.error"));
          }
        )
        .finally(() => {
          // Swal.close();
        });
      this.$swal.close();
    },
    async active(row) {
      await this.$http
        .put(route("TipoMoneda/updateStatus"), row)
        .then(
          async response => {
            console.log(response);
            if (response.body.code === 200) {
              this.notifyMessage("success", this.$t("app.promps.save_success"));
              EventBus.$emit("reload-items");
            } else {
              this.notifyMessage("danger", this.$t("app.promps.error"));
            }
          },
          error => {
            this.notifyMessage("danger", this.$t("app.promps.error"));
          }
        )
        .finally(() => {});
    },
    openItemAdd() {
      EventBus.$emit("monedas-add");
    },
    EditItem(index, row, ref) {
      this.$refs[ref].doClose();
      EventBus.$emit("monedas-edit", row);
    },
    handleDelete(index, row) {
      this.$swal
        .fire({
          title: "Are you sure?",
          text: `You won't be able to revert this!`,
          type: "warning",
          showCancelButton: true,
          confirmButtonClass: "btn btn-success btn-fill",
          cancelButtonClass: "btn btn-danger btn-fill",
          confirmButtonText: "Yes, delete it!",
          buttonsStyling: false
        })
        .then(result => {
          if (result.value) {
            this.deleteRow(row);
            Swal.fire({
              title: "Deleted!",
              text: `You deleted ${row.name}`,
              type: "success",
              confirmButtonClass: "btn btn-success btn-fill",
              buttonsStyling: false
            });
          }
        });
    },
    deleteRow(row) {
      let indexToDelete = this.tableData.findIndex(
        tableRow => tableRow.id === row.id
      );
      if (indexToDelete >= 0) {
        this.tableData.splice(indexToDelete, 1);
      }
    }
  },
  mounted() {
    // Fuse search initialization.
    this.fuseSearch = new Fuse(this.tableData, {
      keys: ["nombre", "abreviatura"],
      threshold: 0.3
    });
    this.init();

    EventBus.$on("reload-items", () => {
      this.init();
    });
  },
  watch: {
    /**
     * Searches through the table data by a given query.
     * NOTE: If you have a lot of data, it's recommended to do the search on the Server Side and only display the results here.
     * @param value of the query
     */
    searchQuery(value) {
      let result = this.tableData;
      if (value !== "") {
        result = this.fuseSearch.search(this.searchQuery);
      }
      this.searchedData = result;
    }
  }
};
</script>
<style>
.form-group .el-input__inner {
  padding: 10px 18px 10px 30px !important;
}
</style>
